import React from "react";
import { Container, Row, Col } from "react-bootstrap";


import { Link } from "react-router-dom";
function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
     
      <Row>
        <Col md="6" className="footer-copywright">
          <div className="white-text">
          <h2 className="main-name" >Quick Links</h2>
          <Link to="/services" style={{textDecoration: 'none',color: '#ffffff'}} >  <h4>Services</h4></Link>
          <Link to="/serviceform" style={{textDecoration: 'none',color: '#ffffff'}} > <h4> Hire Us</h4></Link>
          <Link to="/serviceform" style={{textDecoration: 'none',color: '#ffffff'}} > <h4>Contact</h4></Link>
          <Link to="/about" style={{textDecoration: 'none',color: '#ffffff'}} > <h4>About</h4></Link>
          </div>
        </Col>
       
        <Col md="6" className="footer-copywright">
          <div className="white-text">
          <h2 className="main-name" >Our Services</h2>
         <Link to="/serviceform" style={{textDecoration: 'none',color: '#ffffff'}} > <h4>Build App </h4></Link>
         <Link to="/serviceform" style={{textDecoration: 'none',color: '#ffffff'}} ><h4>Build Web </h4> </Link>
         <Link to="/serviceform" style={{textDecoration: 'none',color: '#ffffff'}} ><h4>Logo Design</h4> </Link>
         <Link to="/serviceform" style={{textDecoration: 'none',color: '#ffffff'}} ><h4>Graphic Design </h4> </Link>
         <Link to="/serviceform" style={{textDecoration: 'none',color: '#ffffff'}} ><h4>Data Science</h4> </Link>
         <Link to="/serviceform" style={{textDecoration: 'none',color: '#ffffff'}} ><h4>Contact Us</h4> </Link>
          </div>
        </Col>
      
     
        <Col md="6" className="footer-copywright white-text">
          <h3>Copyright © {year} Habzon</h3>
        </Col>
        
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
           
          
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
